var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0L12.8037 6.14099L19.5106 6.90983L14.5365 11.474L15.8779 18.0902L10 14.77L4.12215 18.0902L5.46346 11.474L0.489435 6.90983L7.19626 6.14099L10 0Z","fill":"#FDB22B"}));
}

Star.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Star;

Star.default = Star;
